import _ from "lodash";

export const TournamentTypeEnum = {
    Casino: 1,
    Sport: 2,
};

export const TournamentStageEnum = {
    Canceled: -1,
    Finished: 1,
    Live: 2,
    Upcoming: 3,
};

export const TournamentStageViewEnum = _.invert(TournamentStageEnum);